import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/fonts/icons.js'
import './Services/GlobalVariables'
import Loading from 'vue-loading-overlay';
import DrawerLayout from 'vue-drawer-layout'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
  faExclamationCircle, 
  faChartSimple, 
  faUserCheck, 
  faWallet, 
  faArrowRightFromBracket 
} from '@fortawesome/free-solid-svg-icons'

import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import 'vue-loading-overlay/dist/vue-loading.css';

import 'vue-good-table/dist/vue-good-table.css'

import VueGoodTablePlugin from 'vue-good-table';

// Add icons to the library
library.add(
  faExclamationCircle,
  faChartSimple,
  faUserCheck,
  faWallet,
  faArrowRightFromBracket
)

// Register the component globally
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueGoodTablePlugin);
Vue.component('v-select', vSelect)
Vue.component('loading', Loading);
Vue.use(DrawerLayout);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
